import './WorklogCalendar.css'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Calendar } from 'primereact/calendar';
import { Dialog } from "primereact/dialog";
import { useCalender } from '../../../Hooks/Features/Dashboard/useCalender';
import { useCommon } from '../../../Hooks/Common/useCommon';
import ApproveTimesheet from '../../Timesheet/ApproveTimesheet';
import { useEmployeFilter } from '../../../context/EmployeFilterContext';
import { SkeletonContainer } from '../../Loader/Loader';
import { DateObject } from 'react-multi-date-picker';
import Logwork from './Logwork';
import AttendanceTracker from '../../Employeedashboard/AttendanceTracker';
import { Menu } from 'primereact/menu';
import { calculateWordsFromString, dateHoverRange } from '../../../utils/Helper';
import { Dropdown } from 'primereact/dropdown';

function WorklogCalendar() {


  const { getValuePermission } = useCommon();
  const { tagRef, userCode, selectedEmployee, isWorklog, setIsWorklog, logDetails, tableData, handleDateSelected, showTimesheet, setShowTimesheet, dateTemplate, getTimesheetCalendarSummary, approvePopup, setApprovePopup, approvalData, handleSelectAll, sendForApproval, popupDate, setPopupDate, changeMonth, setPopupLogDetails, approveTimePopup, setApproveTimePopup, options, approvalLoader, loader, setLoader, filterValue, setFilterValue, calendarDate, setCalendarDate, pendingLogDate, logLoader, legendItems, logHours, legendMenuRef, legendMenuItems, callAttendanceApi, setCallAttendanceApi, enabelPopup, setEnabelpopup, extensionForm, setExtensionForm, saveExtensions } = useCalender()
  const { badget } = useEmployeFilter();

  return (
    <div className='wc-container h-100'>
      <div className='d-flex justify-content-between align-items-center row-gap-1 flex-wrap mb-2'>
        <div className='d-flex gap-1'>
          <button className={`wc-icons position-relative ${isWorklog ? "bg-dark text-white" : ""}`} onClick={() => setIsWorklog(true)}> <FontAwesomeIcon icon="fa-solid fa-pen-to-square" /></button>
          <button className={`wc-icons position-relative ${!isWorklog ? "bg-dark text-white" : ""}`} onClick={() => setIsWorklog(false)}> <FontAwesomeIcon icon="fa-solid fa-user-clock" /> 
            {badget?.attendance_btn?.[0]?.counts > 0 &&
              <div className='notification-count orange-badge-count d-flex justify-content-center align-items-center' style={{ right: "-2px", top: "-8px" }} id='{"tabname": "timesheet", "data": "approve_timesheet_tab"}' ref={tagRef}>
                {badget?.attendance_btn?.[0]?.counts}
              </div>
            }
          </button>
        </div>
        {parseInt(selectedEmployee?.user_code) === parseInt(userCode) &&
          (isWorklog ? <div className='d-flex gap-1'>

            <button className='sk-btn-primary wc-icons' title='Legends' onClick={(e) => legendMenuRef?.current?.toggle(e)} >
              <FontAwesomeIcon icon="fa-solid fa-info-circle" />
            </button>
            {
              !getValuePermission("extend_request_btn") && <button className='sk-btn-primary wc-icons' title='Extend Request' onClick={(e) => setEnabelpopup(true)} >
                <FontAwesomeIcon icon="fa-solid fa-hand" />
              </button>
            }

            {!getValuePermission("approve_timesheet_tab") && <button className='sk-btn-primary wc-icons position-relative' title="Pending Timesheet" onClick={() => setApproveTimePopup(true)}>
              <FontAwesomeIcon icon="fa-solid fa-calendar-check" />
              {badget?.manager_timesheet_details_tab?.[0]?.counts > 0 &&
                <div className='notification-count orange-badge-count d-flex justify-content-center align-items-center' style={{ right: "-2px", top: "-8px" }}>
                  {badget?.manager_timesheet_details_tab?.[0]?.counts}
                </div>
              }
            </button>}
            <button className='sk-btn-primary wc-icons' title='Send for Approval' onClick={() => {setPopupDate(calendarDate); getTimesheetCalendarSummary("popup", calendarDate)}} >
              <FontAwesomeIcon icon="fa-solid fa-paper-plane" />
            </button>
            <button className='sk-btn-primary wc-icons' title='Refresh' onClick={() => { setLoader(true); getTimesheetCalendarSummary() }}>
              <FontAwesomeIcon icon="fa-solid fa-arrows-rotate" />
            </button>
            <Menu ref={legendMenuRef} model={legendMenuItems} popup className="survey-menu" appendTo={document.body} />
          </div> : <button className='sk-btn-primary wc-icons' title='Refresh' onClick={() => { setCallAttendanceApi(!callAttendanceApi) }} >
            <FontAwesomeIcon icon="fa-solid fa-arrows-rotate" />
          </button>)
        }
      </div>
      {isWorklog ? (
        <div className='card flex text-center worklog-calendar flex-column' style={{ height: "88%" }}>
          {loader ? <div style={{ height: "100%", width: "100%" }}><SkeletonContainer /></div> :
            <Calendar value={calendarDate} onChange={(e) => { handleDateSelected(e.value); setFilterValue((prev) => ({...prev, logworkDate: e?.value ? new Date(e?.value) : ""})) }} inline dateTemplate={dateTemplate} style={{ width: "100%" }} onMonthChange={(e) => {setCalendarDate(new Date(e?.year, e?.month - 1, 1))}}/>
          }
        </div>
      ) : (
        <div className='card flex text-center worklog-calendar flex-column' style={{ height: "88%" }}>
          <AttendanceTracker callApi={callAttendanceApi} worklogDate={calendarDate} setWorklogDate={setCalendarDate} />
        </div>
      )}
      <div>
        <Dialog
          draggable={false}
          visible={showTimesheet}
          onHide={() => { setFilterValue({ hoveredRange: [new DateObject(), new DateObject()] }); getTimesheetCalendarSummary(); setShowTimesheet(false); }}
          header={`${logHours?.date} [ Hours: ${logHours?.hours}h ]`}
          style={{ width: "95vw", height: "90vh" }}
          className='wc-timesheet-dialog p-0'
        >
          <Logwork pendingLogDate={pendingLogDate} closePopup={() => { setShowTimesheet(false); }} onSave={() => { getTimesheetCalendarSummary(); }} handleDateSelected={handleDateSelected} date={filterValue?.logworkDate} timesheetData={tableData} setFilterValue={setFilterValue} filterValue={filterValue} loader={logLoader} />
        </Dialog>
      </div>
      <Dialog header="Send for Approval" visible={approvePopup} draggable={false} className='modal-small' onHide={() => { setApprovePopup(false); getTimesheetCalendarSummary(); setPopupLogDetails({}) }} style={{ maxHeight: "95%" }}>
        <div>
          <div className='d-flex justify-content-between'>
            <div className="calendar-header-controls w40">
              <button className="button btn-default w10 d-flex justify-content-center fw-bold" onClick={() => changeMonth(-1)}><FontAwesomeIcon icon="fa-solid fa-angle-left" /></button>
              <span className="month-year w70 d-flex justify-content-center align-items-center" >
                <Calendar
                  value={popupDate}
                  onChange={(e) => {setPopupDate(e.value); getTimesheetCalendarSummary("popup", e?.value);}}
                  view="month"
                  dateFormat="MM yy"
                  showIcon={false}
                  readOnlyInput
                  touchUI={false}
                  className="attendance-calendar-input"
                />
              </span>
              <button className="button btn-default button btn-default w10 d-flex justify-content-center fw-bold" onClick={() => changeMonth(1)}><FontAwesomeIcon icon="fa-solid fa-angle-right" /></button>
            </div>
            <button className='btn-primary w30' onClick={sendForApproval}> <i className='icon-send-outline'></i> {approvalLoader ? <div className="spinner-border" role="status" style={{ width: "15px", height: "15px" }}><span className="sr-only"></span></div> :  "Send for Approval"}</button>
          </div>
          <div className='d-flex gap-3 mt-2'>
            <table className='text-center'>
              <thead>
                <tr className='border'>
                  <th><input type='checkbox' onChange={(e) => handleSelectAll("firstHalf", e)} /></th>
                  <th>Date</th>
                  <th>Logs</th>
                </tr>
              </thead>
              <tbody>
                {approvalData?.firstHalf?.map((item, index) => (
                  <tr className='border' key={index}>
                    <td>{item?.date && <input type='checkbox' checked={item?.sent} onChange={(e) => handleSelectAll("firstHalf", e, item)} disabled={item?.disabled} />}</td>
                    <td>{item?.date}</td>
                    <td className='w20'>
                      <div className={`d-flex justify-content-center align-items-center ${item?.reject_remark ? "gap-2" : ""}`} style={{ backgroundColor: item?.bg_color, borderRadius: "5px", fontWeight: item?.bg_color?.length === 0 ? "" : "bold" }}>
                        <div>{item?.log_hours}</div>
                        <div>{item?.reject_remark ? <span style={{ cursor: "pointer" }} title={"Rejection Reason:- " + item?.reject_remark}><FontAwesomeIcon icon="fa-solid fa-triangle-exclamation" /></span> : <></>}</div>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>

            <table className='text-center'>
              <thead>
                <tr className='border'>
                  <th><input type='checkbox' onClick={(e) => handleSelectAll("secondHalf", e)} /></th>
                  <th>Date</th>
                  <th>Logs</th>
                </tr>
              </thead>
              <tbody>
                {approvalData?.secondHalf?.map((item, index) => (
                  <tr className='border' key={index}>
                    <td>{item?.date ? <input type='checkbox' checked={item?.sent} onChange={(e) => handleSelectAll("secondHalf", e, item)} disabled={item?.disabled} /> : <span>&nbsp;</span>}</td>
                    <td>{item?.date}</td>
                    <td className='w20'>
                      <div className={`d-flex justify-content-center align-items-center ${item?.reject_remark ? "gap-2" : ""}`} style={{ backgroundColor: item?.bg_color, borderRadius: "5px", fontWeight: item?.bg_color?.length === 0 ? "" : "bold" }}>
                        <div>{item?.log_hours}</div>
                        <div>{item?.reject_remark ? <span style={{ cursor: "pointer" }} title={item?.reject_remark}><FontAwesomeIcon icon="fa-solid fa-triangle-exclamation" /></span> : <></>}</div>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </Dialog>
      <Dialog
        modal={true}
        draggable={false}
        className='modal-large'
        style={{ height: "70vh" }}
        visible={approveTimePopup}
        onHide={() => setApproveTimePopup(false)}
      >
        <div className='pending-timesheet'>
          <ApproveTimesheet userOptions={options?.users} hover={[,]} />
        </div>
      </Dialog>
      <Dialog visible={enabelPopup} modal onHide={() => { setEnabelpopup(false) }} className='modal-small' style={{ width: "100px" }} draggable={false} header={() => (<div className="d-flex align-items-center gap-2"> <span>Extend Request</span></div>)}          >
        <div className="w-100 mb-2 inspectra-calendar">
          <label className="form-label w-100">Select Date</label>
          <Calendar value={extensionForm.apply_enable_datetime} onChange={(e) => { setExtensionForm(prev => ({ ...prev, apply_enable_datetime: e.value, reason: "" })) }} dateFormat='dd-mm-yy' style={{ height: "100%" }} className="sk-input-dd" />
        </div>
        <div className="w-100 mb-2">
          <label className="form-label w-100">Approver</label>
          <Dropdown placeholder="Select Approver" options={options?.approverList} value={extensionForm?.approver} optionLabel="user_display_name" optionValue="user_code" className="sk-input-dd" onChange={(e) => {
            setExtensionForm((prev) => ({ ...prev, approver: e.target.value }));
          }} filter filterInputAutoFocus optionValue="user_code" />
        </div>
        <div className="w-100 mb-2">
          <label className="form-label w-100">Reason</label>
          <textarea className=" w-100" row={4} value={extensionForm.reason} onChange={(e) => setExtensionForm(prev => ({ ...prev, reason: e.target.value }))} style={{ width: "200px" }} placeholder="Enter extension reason..." />
        </div>
        <div className="w100 mt-1">
          <div>{calculateWordsFromString(extensionForm.reason) > 5
            ? "" : `${calculateWordsFromString(extensionForm.reason)}/5 words`
          }</div>
        </div>
        <div className="d-flex justify-content-end gap-2">
          <button className="btn btn-primary btn-sm" onClick={saveExtensions} >Save Extension</button>
        </div>
      </Dialog>

    </div>
  )
}

export default WorklogCalendar